"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var Code = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Code, _super);
    function Code() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '查询银行卡信息接口';
        _this.code = '101003';
        _this.desc = '查询银行卡信息接口';
        _this.requestParams = new bankCard_1.CodeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Code;
}(service_1.BaseService));
exports.Code = Code;
//# sourceMappingURL=code.js.map